export const PROGRAM_OUTCOME_CHUNK_SIZE = 150;
export const FIELD_PRACTICES_CHUNK_SIZE = 50;
